export default __webpack_public_path__ + "static/1235-a64d81656d0af9acc2faaee91b05ec8c.gif";